(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    // JON EDIT - truncate
  document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('.text-block-truncate-toggle');
    const truncatedBlock = e.target.closest('.text-block--truncate:not(.is-expanded)');

    // If a link or other interactive element inside the text was clicked, let it behave normally
    if (truncatedBlock && e.target.closest('a, button, input, select, textarea')) return;

    let block;
    if (toggleBtn) {
      block = toggleBtn.closest('.text-block-truncate-wrapper')?.previousElementSibling;
    } else if (truncatedBlock) {
      block = truncatedBlock;
    } else {
      return;
    }

    if (block) {
      block.classList.add('is-expanded');
      const wrapper = block.nextElementSibling;
      if (wrapper && wrapper.classList.contains('text-block-truncate-wrapper')) {
        wrapper.remove();
      }
    }
  });

  document.querySelectorAll('.text-block--truncate').forEach(block => {
    const wrapper = block.nextElementSibling;
    if (wrapper && wrapper.classList.contains('text-block-truncate-wrapper')) {
      if (block.scrollHeight <= block.clientHeight + 2) {
        wrapper.remove();
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
